import { render } from "./QintuPlatform.vue?vue&type=template&id=a5f533ec&scoped=true"
import script from "./QintuPlatform.vue?vue&type=script&lang=js"
export * from "./QintuPlatform.vue?vue&type=script&lang=js"

import "./QintuPlatform.vue?vue&type=style&index=0&id=a5f533ec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5f533ec"]])

export default __exports__